import { createContext, useContext, useState, useEffect } from "react";
import { adminApi } from "../lib/api";

const Ctx = createContext(null);
export const useAdminAuth = () => useContext(Ctx);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=guest, obj=auth

  useEffect(() => {
    const t = localStorage.getItem("vs_admin_token");
    if (!t) { setAdmin(false); return; }
    adminApi.get("/admin/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => { localStorage.removeItem("vs_admin_token"); setAdmin(false); });
  }, []);

  const login = async (email, password) => {
    const r = await adminApi.post("/admin/auth/login", { email, password });
    localStorage.setItem("vs_admin_token", r.data.token);
    setAdmin(r.data.admin);
  };
  const logout = () => { localStorage.removeItem("vs_admin_token"); setAdmin(false); };

  return <Ctx.Provider value={{ admin, login, logout }}>{children}</Ctx.Provider>;
}
